module.exports = __webpack_public_path__ + "static/media/img-2.121d63bb.jpg";